import React from 'react';
import PropTypes from 'prop-types';

const Menu = ({ menu }) => {
  if (!menu) return null;

  const { home, application, languages, ratings, show, hide } = menu;

  return (
    <nav id="nav-wrap">
      <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
        {show}
      </a>
      <a className="mobile-btn" href="#home" title="Hide navigation">
        {hide}
      </a>

      <ul id="nav" className="nav">
        <li className="current">
          <a className="smoothscroll" href="#home">
            {home}
          </a>
        </li>

        <li>
          <a className="smoothscroll" href="#application">
            {application}
          </a>
        </li>

        <li>
          <a className="smoothscroll" href="#languages">
            {languages}
          </a>
        </li>

        <li>
          <a className="smoothscroll" href="#ratings">
            {ratings}
          </a>
        </li>
      </ul>
    </nav>
  );
};

Menu.propTypes = {
  menu: PropTypes.shape({
    home: PropTypes.string,
    application: PropTypes.string,
    languages: PropTypes.string,
    ratings: PropTypes.string,
    show: PropTypes.string,
    hide: PropTypes.string,
  }).isRequired,
};

export default Menu;
